module.exports = __webpack_public_path__ + "img/thumbtack.539c5d59.svg";